import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL 
    ? `${process.env.REACT_APP_API_URL}/api`
    : 'http://localhost:5000/api'
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    // ✅ FIX: Login page pe interceptor kaam nahi karega
    // /login ya / pe hain toh sirf error return karo — redirect mat karo
    const onLoginPage = window.location.pathname === '/login' || 
                        window.location.pathname === '/';

    if (onLoginPage) {
      // Login page ke errors Login.js khud handle karega
      return Promise.reject(error);
    }

    // Sirf logged-in pages pe 401 handle karo
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('isSuperAdmin');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      window.location.href = '/?openLogin=true';

    }
    
    // Sirf logged-in pages pe 403 handle karo
    if (error.response?.status === 403 && 
        error.response?.data?.errorCode === 'ACCOUNT_DEACTIVATED') {
      localStorage.removeItem('token');
      localStorage.removeItem('isSuperAdmin');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      window.location.href = '/?openLogin=true';
    }

    // ✅ Subscription expired ya nahi hai — pricing pe bhejo
    if (error.response?.status === 403 && 
        (error.response?.data?.errorCode === 'NO_SUBSCRIPTION' ||
         error.response?.data?.errorCode === 'SUBSCRIPTION_EXPIRED')) {
      window.location.href = '/pricing';
    }
    
    return Promise.reject(error);
  }
);

export default API;